import { HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod } from '@api-new/authservice';
import { BUY_TO_LET_FLOW } from '@app/sign-up/constants/buy-to-let-flow';
import { ENTRY_FLOW } from '@app/sign-up/constants/entry-flow';
import { MORTGAGE_MONITOR_FLOW } from '@app/sign-up/constants/mortgage-monitor-flow';
import { REMORTGAGE_NOW_FLOW } from '@app/sign-up/constants/remotgage-now-flow';
import { SignUpState } from '@app/sign-up/models/sign-up.state';
import { FIRST_TIME_BUYER_FLOW } from '@shared-lib/constants/sign-up/first-time-buyer-flow';
import { MOVING_HOME_FLOW } from '@shared-lib/constants/sign-up/moving-home-flow';
import { SignUpEntryLandingEnum } from '@shared-lib/enums/sign-up/sign-up-entry-landing.enum';

export const getPreviousStep = (appState: SignUpState): number => {
  const currentStep = appState.flow.currentStep;

  if (currentStep === ENTRY_FLOW.MortgageSwitchUrgency) {
    return ENTRY_FLOW.Landing;
  }

  // Mortgage Monitor
  if (appState.flow.entity.creationMethod === HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_MORTGAGE_MONITOR) {
    return handleMortgageMonitorFlow(appState);
  }

  // Remortgage Now
  if (appState.flow.entity.creationMethod === HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_REMORTGAGE_NOW) {
    return handleRemortgageNowFlow(appState);
  }

  // First Time Buyer
  if (appState.flow.entity.creationMethod === HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_FIRST_TIME_BUYER) {
    return handleFirstTimeBuyerFlow(appState);
  }

  // Moving Home
  if (appState.flow.entity.creationMethod === HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_MOVING_HOME) {
    return handleMovingHomeFlow(appState);
  }

  // Buy To Let
  if (appState.flow.entity.creationMethod === HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_BUY_TO_LET) {
    return handleBuyToLetFlow(appState);
  }

  return currentStep - 1;
};

const handleMortgageMonitorFlow = (appState: SignUpState): number => {
  const currentStep = appState.flow.currentStep;

  if (currentStep === MORTGAGE_MONITOR_FLOW.PropertyAddress) {
    if (appState.flow.entity.landing === SignUpEntryLandingEnum.TrackMortgage) {
      return ENTRY_FLOW.Landing;
    }

    return ENTRY_FLOW.MortgageSwitchUrgency;
  }
  if (currentStep === MORTGAGE_MONITOR_FLOW.UserCreate && appState.mortgage.entity == null) {
    return MORTGAGE_MONITOR_FLOW.MortgageLender;
  }

  return appState.flow.currentStep - 1;
};

const handleRemortgageNowFlow = (appState: SignUpState): number => {
  const currentStep = appState.flow.currentStep;

  if (currentStep === REMORTGAGE_NOW_FLOW.PropertyAddress) {
    return ENTRY_FLOW.MortgageSwitchUrgency;
  }
  if (currentStep === REMORTGAGE_NOW_FLOW.SmartSearchLiveResults && appState.mortgage.entity == null) {
    return REMORTGAGE_NOW_FLOW.MortgageLender;
  }

  return appState.flow.currentStep - 1;
};

const handleFirstTimeBuyerFlow = (appState: SignUpState): number => {
  const currentStep = appState.flow.currentStep;

  if (currentStep === FIRST_TIME_BUYER_FLOW.SmartSearchBuyingProcessStage) {
    return ENTRY_FLOW.BuyerType;
  }

  return appState.flow.currentStep - 1;
};

const handleMovingHomeFlow = (appState: SignUpState): number => {
  const currentStep = appState.flow.currentStep;

  if (currentStep === MOVING_HOME_FLOW.SmartSearchBuyingProcessStage) {
    return ENTRY_FLOW.BuyerType;
  }
  if (currentStep === MOVING_HOME_FLOW.UserCreate && appState.smartSearch.entity?.mortgageProductId != null) {
    return MOVING_HOME_FLOW.SmartSearchLiveResults;
  }
  if (currentStep === MOVING_HOME_FLOW.UserCreate && appState.mortgage.entity == null) {
    return MOVING_HOME_FLOW.MortgageLender;
  }

  return appState.flow.currentStep - 1;
};

const handleBuyToLetFlow = (appState: SignUpState): number => {
  const currentStep = appState.flow.currentStep;

  if (currentStep === BUY_TO_LET_FLOW.SmartSearchLiveResults) {
    return ENTRY_FLOW.BuyerType;
  }

  return appState.flow.currentStep - 1;
};
